import styled from 'styled-components';
import theme from 'styled-theming';

export const GlassEffect = theme('name', {
  light: `
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.17);
  `,
  dark: `
    background: rgba(20, 20, 20, 0.25);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  `,
});

export const HeaderSection = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${GlassEffect}

    min-height: 72px;
    padding: 0 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .user {
      display: flex;
      align-items: center;
      gap: 10%;

      .shell-avatar {
        cursor: pointer;
      }

      .theme-switcher {
        width: 70px;
      }
    }
  }

  .header-title {
    padding: 0 10px;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
  }

  .header-title-up {
    display: block;
    font-size: 12px;
  }

  .header-title-down {
    font-weight: 400;
  }
`;
